import React from "react";
import { LazyLoadRoutes } from "routes/lazyLoadRoutes";
import { Route } from "react-router-dom";
import {
  AI_PAGE_BUILDER_ROUTE_IDS,
  AI_PAGE_BUILDER_ROUTE_KEYS,
} from "./AiSalePageBuilder.constants";

const SelectTemplateRoute = React.lazy(() =>
  import("../routes/SelectTemplateRoute")
);
const EditorRoute = React.lazy(() => import("../routes/EditorRoute"));

export const AI_PAGE_BUILDER_CUSTOM_ROUTES = [
  <Route
    exact
    key={
      AI_PAGE_BUILDER_ROUTE_IDS[AI_PAGE_BUILDER_ROUTE_KEYS.generate_template]
    }
    path={
      AI_PAGE_BUILDER_ROUTE_IDS[AI_PAGE_BUILDER_ROUTE_KEYS.generate_template]
    }
    render={(props) => (
      <LazyLoadRoutes props={props} LazyElement={SelectTemplateRoute} />
    )}
    noLayout
  />,
  <Route
    exact
    key={AI_PAGE_BUILDER_ROUTE_IDS[AI_PAGE_BUILDER_ROUTE_KEYS.select_template]}
    path={AI_PAGE_BUILDER_ROUTE_IDS[AI_PAGE_BUILDER_ROUTE_KEYS.select_template]}
    render={(props) => (
      <LazyLoadRoutes props={props} LazyElement={SelectTemplateRoute} />
    )}
    noLayout
  />,
  <Route
    exact
    key={AI_PAGE_BUILDER_ROUTE_IDS[AI_PAGE_BUILDER_ROUTE_KEYS.editor]}
    path={AI_PAGE_BUILDER_ROUTE_IDS[AI_PAGE_BUILDER_ROUTE_KEYS.editor]}
    render={(props) => (
      <LazyLoadRoutes props={props} LazyElement={EditorRoute} />
    )}
    noLayout
  />,
];
